import { APIRoute } from '@/modules/utils'
import { Conversation } from '@/dataV3/Conversation/Conversation'
import { IRI } from 'emt-library'

export const Route = (path: IRI): APIRoute => ({
  method: 'GET',
  path,
})

export type Body = never

export type Response = Conversation
